import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { servesPortal } from '@/lib/portalHost';

export default function Forbidden() {
  const { t } = useTranslation();
  const patientHost = !servesPortal('clinician');
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-4xl font-semibold">{t('Access denied')}</h1>
      <p className="max-w-md text-muted-foreground">
        {t('You do not have permission to view this page. Contact your administrator if you believe this is a mistake.')}
      </p>
      <Button asChild>
        <Link to={patientHost ? '/logout' : '/patients'}>
          {t(patientHost ? 'Back to sign in' : 'Back to patients')}
        </Link>
      </Button>
    </div>
  );
}
